import React from 'react';
import { HeroServices } from '../components/HeroServices';
import { AboutSection } from '../components/AboutSection';
import { ValuesSection } from '../components/ValuesSection';
import { ContactSection } from '../components/ContactSection';
type PageType = 'home' | 'commercial' | 'services' | 'residential';
interface HomePageProps {
  onNavigate: (page: PageType) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <main data-id="element-339">
      <HeroServices onNavigate={onNavigate} data-id="element-340" />
      <AboutSection data-id="element-341" />
      <ValuesSection data-id="element-342" />
      <ContactSection data-id="element-343" />
    </main>;
}